module.exports = __webpack_public_path__ + "static/img/Sarah.bd10f2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photos/board/Sarah.jpg
// module id = Y3IE
// module chunks = 0